/* eslint-disable react/jsx-pascal-case */
import Profile_Customize_ColorBtn_Button from "./Profile_Customize_ColorBtn_Button";
import {connect} from "react-redux";

const Profile_Customize_ColorBtn = (props) => {
    const colors = ["blue", "yellow", "pink", "violet", "orange", "green"];

    return(
        <div className="profile_customize_section">
            <h3 className="profile_customize_section_heading">Color</h3>
            <div className={`profile_customize_section_main  background_change_${props.color_background}`}>
                {
                    colors.map((color,i) => {
                        return <Profile_Customize_ColorBtn_Button 
                            key={i} 
                            color={color}
                        />
                    })
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Profile_Customize_ColorBtn);